import { c as _c } from "react/compiler-runtime";
import { ApolloProvider } from "@apollo/client";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/next";
import type { Session } from "next-auth";
import { SessionProvider } from "next-auth/react";
import { type AppProps } from "next/app";
import { SnackbarProvider } from "notistack";
import React from "react";
import "symbol-observable";
import { ProjectBrowser } from "#/features/project/ui/ProjectBrowser/ProjectBrowser";
import { ProjectBrowserProvider } from "#/features/project/ui/ProjectBrowser/ProjectBrowserContext";
import { apolloClient } from "#/graphql/apolloClient";
import { type I18nProps } from "#/i18n/getI18nProps";
import { api } from "#/shared/api";
import { EmotionCacheProvider } from "#/shared/emotion/EmotionCacheContext";
// `_document` is server-only; importing fonts here registers @font-face + CSS vars in the client bundle.
import "#/shared/fonts/appFonts";
import { SnackbarCloseButton } from "#/shared/ui/atoms/SnackbarCloseButton";
import { I18nProvider } from "#/shared/ui/providers/I18nProvider";
import { StateThemeProvider } from "#/shared/ui/providers/StateThemeProvider";
import { isSnackbarClosable } from "#/shared/ui/snackbarClosability";
import { ReduxProvider } from "#/store/provider";
import type { SsrDeviceType } from "#/themes";
import "#/styles/globals.css";
import "overlayscrollbars/overlayscrollbars.css";
type MyAppProps = {
  session: Session | null;
  i18n?: I18nProps;
  ssrDeviceType?: SsrDeviceType;
};
const MyApp: React.FC<AppProps<MyAppProps>> = t0 => {
  const $ = _c(18);
  const {
    Component,
    pageProps
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      containerAnchorOriginBottomLeft: "snackbar-mobile-bottom-margin",
      containerAnchorOriginBottomCenter: "snackbar-mobile-bottom-margin",
      containerAnchorOriginBottomRight: "snackbar-mobile-bottom-margin"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== Component || $[2] !== pageProps) {
    t2 = <Component {...pageProps} />;
    $[1] = Component;
    $[2] = pageProps;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  let t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ProjectBrowser />;
    t4 = <Analytics />;
    t5 = <SpeedInsights />;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t2) {
    t6 = <ProjectBrowserProvider>{t2}{t3}{t4}{t5}</ProjectBrowserProvider>;
    $[7] = t2;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== pageProps.i18n || $[10] !== t6) {
    t7 = <SnackbarProvider maxSnack={4} action={_temp} classes={t1}><I18nProvider i18n={pageProps.i18n}>{t6}</I18nProvider></SnackbarProvider>;
    $[9] = pageProps.i18n;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== pageProps.ssrDeviceType || $[13] !== t7) {
    t8 = <ApolloProvider client={apolloClient}><StateThemeProvider ssrDeviceType={pageProps.ssrDeviceType}>{t7}</StateThemeProvider></ApolloProvider>;
    $[12] = pageProps.ssrDeviceType;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== pageProps.session || $[16] !== t8) {
    t9 = <EmotionCacheProvider><ReduxProvider><SessionProvider session={pageProps.session}>{t8}</SessionProvider></ReduxProvider></EmotionCacheProvider>;
    $[15] = pageProps.session;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
};
export default api.withTRPC(MyApp);
function _temp(snackbarKey) {
  return isSnackbarClosable(snackbarKey) ? <SnackbarCloseButton snackbarKey={snackbarKey} /> : null;
}